import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Operational data changes from other screens (purchases, repacking, payments),
      // so always refetch on mount/focus; cached data still renders instantly.
      staleTime: 0,
      refetchOnWindowFocus: true,
      gcTime: 1000 * 60 * 10,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
